export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-md">
                <i className="ri-flashlight-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl text-background-50 whitespace-nowrap">
                爆料专区
              </span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed mb-4">
              爆料专区汇集全网最新爆料、今日爆料及热门爆料合集，每日更新独家爆料视频与内幕猛料，满足你对新鲜瓜料的好奇心，第一时间获取劲爆资讯。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-foreground-800 text-background-300 hover:text-primary-400 hover:bg-foreground-700 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-foreground-800 text-background-300 hover:text-primary-400 hover:bg-foreground-700 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-foreground-800 text-background-300 hover:text-primary-400 hover:bg-foreground-700 transition-colors cursor-pointer">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-medium text-background-50 text-sm mb-4">快速导航</h3>
            <nav className="flex flex-col gap-2">
              <a href="#topics" className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">热门话题</a>
              <a href="#ranking" className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">热议榜单</a>
              <a href="#index" className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">专题合集</a>
              <a href="#media" className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">独家视频</a>
              <a href="#updates" className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">实时快讯</a>
            </nav>
          </div>

          <div>
            <h3 className="font-medium text-background-50 text-sm mb-4">关于我们</h3>
            <nav className="flex flex-col gap-2">
              <a href="#about" className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">平台介绍</a>
              <a href="#contact" className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">联系我们</a>
              <a href="#features" className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">平台优势</a>
              <a href="#faq" className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">常见问题</a>
              <a href="#app" className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">移动客户端</a>
            </nav>
          </div>

          <div>
            <h3 className="font-medium text-background-50 text-sm mb-4">合作伙伴</h3>
            <p className="text-background-500 text-xs leading-relaxed">
              合作伙伴信息持续更新中，欢迎优质媒体与内容平台洽谈合作。
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; 2026 爆料专区 BaoliaoZone. 本站内容仅供信息参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}